var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PerformanceUser',{ref:"performanceUser"}),_c('Expedition',{ref:"expedition"}),_c('HistoryRetur',{ref:"historyRetur"}),_c('ChartTransaction',{ref:"chartTransaction"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }